import { hooks, PreviewLoader } from '@datacamp/teach-integration';
import * as React from 'react';
import { ExerciseLoader } from './ExerciseLoader';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const Loader = _ref => {
  let {
    children,
    environment,
    exerciseId,
    getData,
    language,
    nextIds,
    onError,
    setData,
    validate
  } = _ref;
  const {
    chapterHash,
    courseHash,
    isPreview
  } = hooks.usePreview();
  if (isPreview) {
    return ___EmotionJSX(PreviewLoader, {
      chapterHash: chapterHash,
      courseHash: courseHash,
      environment: environment,
      exerciseId: exerciseId,
      getData: getData,
      nextIds: nextIds,
      onError: onError,
      setData: setData,
      validate: validate
    }, children);
  }
  return ___EmotionJSX(ExerciseLoader, {
    environment: environment,
    exerciseId: exerciseId,
    getData: getData,
    language: language,
    nextIds: nextIds,
    onError: onError,
    setData: setData,
    validate: validate
  }, children);
};